
<template>
  <div class="bgfff out_wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="充值记录" name="1">
        <div class="flex_between mb20">
          <div class="total_box flex flex1">
            <div class="mr20">累计充值金额：<span class="active_color">￥{{ $formatCurrency(summary.all_real) || '0.00' }}</span></div>
            <div class="mr20">商户号充值金额：<span class="active_color">￥{{ $formatCurrency(summary.all_mch) || '0.00' }}</span></div>
            <div class="mr20">累计服务费金额：<span class="active_color">￥{{ $formatCurrency(summary.all_service) || '0.00' }}</span></div>
            <div>冻结金额：<span class="active_color">￥{{ $formatCurrency(summary.frozen) || '0.00' }}</span></div>
          </div>
          <el-button class="ml20" type="primary" @click="toCharge">普通充值</el-button>
          <el-button class="ml20" type="primary" @click="interconvert">商户号互转</el-button>
        </div>
        <div class="flex" style="flex-wrap: wrap;">
          <el-card
            v-for="item in mch_arr"
            :key="item.mch_id"
            class="box-card pr"
            :class="item.type == 1 ? 'box_wxbg' : 'box_zfbbg'"
          >
            <div><span style="margin-left:4px;">商户号：</span><span>{{ item.mch_id }}</span></div>
            <div class="mt10" style="margin-left: -10px;">
              <span>可用金额：</span><span>￥{{ $formatCurrency(item.use_price) || '0.00' }}</span></div>
            <div class="box_icon"><img
              :src="require(`../../assets/${item.type == 1 ? 'wxicon' : 'zfbicon' }.png`)"
              alt=""
            ></div>
          </el-card>
        </div>
        <div class="between search">
          <div class="flex1">
            <el-form ref="rechargeForm" label-width="82px" :model="queryControl">
              <div class="form-box">
                <el-form-item label="充值金额:" class="formItem">
                  <price-range :obj="queryControl" @PChange="queryControl = {...$event}" />
                </el-form-item>
                <el-form-item label="支付时间:" class="formItem">
                  <el-date-picker
                    v-model="queryControl.time"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="开始日期"
                    :clearable="true"
                    end-placeholder="结束日期"
                    :editable="false"
                    :value-format="'yyyy-MM-dd'"
                    unlink-panels
                    :picker-options="pickerOptions"
                    @change="query"
                  />
                </el-form-item>
                <el-form-item label="状态:" class="formItem">
                  <el-select v-model="queryControl.status" class="selectWith120" placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option label="待确认" value="1" />
                    <el-option label="已完成" value="2" />
                    <el-option label="已撤销" value="-1" />
                  </el-select>
                </el-form-item>
                <!-- <el-form-item>
                <el-button type="primary" @click="query">查询</el-button>
              </el-form-item> -->
              </div>
            </el-form>
          </div>
          <div class="right">
            <el-button type="primary" @click="query">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </div>
        </div>
        <zf-table
          :columns="columnRechange"
          :data-source="tableData"
          :total="queryControl.total"
          :page-size="queryControl.pageSize"
          :page-num="queryControl.page"
          @change="handlePageChangeRechange"
        >
          <!-- 充值金额 -->
          <template slot="price" slot-scope="{ row }">
            <!-- <img src="../../assets/title_icon.png" alt="" style="width:5px"> -->
            ￥{{ $formatCurrency(row.status === 1 ? row.recharge_price : row.real_price) }}
          </template>
          <template slot="price-header">
            <span class="mr5">充值金额</span>
            <el-tooltip effect="dark" content="含服务费" placement="top">
              <i class="el-icon-warning c6" />
            </el-tooltip>
          </template>
          <!-- 服务费率 -->
          <template slot="rate" slot-scope="{ row }">
            {{ row.rate }}%
          </template>
          <!-- 商户号充值金额 -->
          <template slot="mch_price" slot-scope="{ row }">
            ￥{{ $formatCurrency(row.mch_price) }}
          </template>
          <!-- 商户号 -->
          <template slot="mch_id" slot-scope="{ row }">
            <a v-if="row.mch_id.includes(',')" class="active_color" @click="rechargeDetail(row)">查看</a>
            {{ row.mch_id }}
          </template>
          <!-- 充值类型 -->
          <template slot="recharge_type" slot-scope="{ row }">
            <span v-if="row.recharge_type == 1">普通充值</span>
            <span v-if="row.recharge_type == 2">返现充值</span>
            <span v-if="row.recharge_type == 3">商户号互转</span>
            <span v-if="row.recharge_type == 4">备用金充值</span>
          </template>
          <!-- 服务费 -->
          <template slot="service_price" slot-scope="{ row }">
            ￥{{ $formatCurrency(row.service_price) }}
          </template>
          <!-- 充值时间 -->
          <template slot="create_time" slot-scope="{ row }">
            {{ row.create_time || '-' }}
          </template>
          <!-- 状态 -->
          <template slot="status" slot-scope="{ row }">
            <span v-if="row.status == -1" class="nouse_bg plub_width inline">撤销</span>
            <span v-if="row.status == 1" class="wait_bg plub_width inline">待确认</span>
            <span v-if="row.status == 2" class="ableuse_bg plub_width inline">已完成</span>
          </template>
          <!-- 操作 -->
          <template slot="action" slot-scope="{ row }">
            <a v-if="row.status == 1" class="active_color" title="极速到账" @click="quicklyRecharge(row)">极速到账</a>
            <el-divider v-if="row.status == 1" direction="vertical" />
            <a v-if="row.status == 1" class="del" title="撤销" @click="backOut(row)">撤销</a>
            <a class="active_color" title="查看凭证" @click="viewPic(row.pic)">查看凭证</a>
          </template>
        </zf-table>
      </el-tab-pane>
      <el-tab-pane label="退款记录" name="2">
        <div class="flex_between mb20">
          <div class="total_box flex flex1">
            <div class="mr20">累计商户号退款金额：<span class="active_color">￥{{ $formatCurrency(summaryRefund.all_mch) || '0.00'
            }}</span></div>
            <div class="mr20">累计服务费退款：<span class="active_color">￥{{ $formatCurrency(summaryRefund.all_service) ||
              '0.00' }}</span></div>
            <div>累计退款金额：<span class="active_color">￥{{ $formatCurrency(summaryRefund.all_withdrawal) || '0.00' }}</span>
            </div>
          </div>
          <el-button class="ml20" type="primary" @click="refundFn">退款</el-button>
        </div>
        <div class="flex" style="flex-wrap: wrap;">
          <el-card
            v-for="item in mch_arr"
            :key="item.mch_id"
            class="box-card pr"
            :class="item.type == 1 ? 'box_wxbg' : 'box_zfbbg'"
          >
            <div><span>{{ item.type == 1 ? '微信' : '支付宝' }}商户号：</span><span>{{ item.mch_id }}</span></div>
            <div class="mt10"><span>可用金额：</span></div>
            <div class="mt10"><span>￥{{ $formatCurrency(item.use_price) || '0.00' }}</span></div>
            <div class="box_icon"><img
              :src="require(`../../assets/${item.type == 1 ? 'wxicon' : 'zfbicon' }.png`)"
              alt=""
            ></div>
          </el-card>
        </div>
        <div class="between search">
          <div class="flex1">
            <el-form ref="rechargeForm" label-width="82px" :model="reFundFormQuery">
              <div class="form-box">
                <el-form-item label="退款时间:" class="formItem">
                  <el-date-picker
                    v-model="reFundFormQuery.time"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="开始日期"
                    :clearable="true"
                    end-placeholder="结束日期"
                    :editable="false"
                    :value-format="'yyyy-MM-dd'"
                    unlink-panels
                    :picker-options="pickerOptions"
                    @change="queryRefund"
                  />
                </el-form-item>
                <el-form-item label="状态:" class="formItem">
                  <el-select v-model="reFundFormQuery.status" class="selectWith120" placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option label="待确认" value="1" />
                    <el-option label="已完成" value="2" />
                    <el-option label="已撤销" value="-1" />
                  </el-select>
                </el-form-item>
                <div>
                  <el-button type="primary" @click="queryRefund">查询</el-button>
                  <el-button @click="resetRefund">重置</el-button>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <zf-table
          :columns="column"
          :data-source="list"
          :total="reFundFormQuery.total"
          :page-size="reFundFormQuery.pageSize"
          :page-num="reFundFormQuery.page"
          @change="handlePageChange"
        >
          <!-- 商户号退款金额 -->
          <template slot="mch_price" slot-scope="{ row }">
            ￥{{ $formatCurrency(row.mch_price) }}
          </template>
          <!-- 商户号 -->
          <template slot="mch_id" slot-scope="{ row }">
            <a v-if="row.mch_id.includes(',')" class="active_color" @click="withdrawalDetail(row)">查看</a>
            {{ row.mch_id }}
          </template>
          <!-- 退款服务费 -->
          <template slot="service_price" slot-scope="{ row }">
            ￥{{ $formatCurrency(row.service_price) }}
          </template>
          <!-- 服务费率 -->
          <template slot="rate" slot-scope="{ row }">
            {{ row.rate }}%
          </template>
          <!-- 实际退款金额 -->
          <template slot="withdrawal_price" slot-scope="{ row }">
            ￥{{ $formatCurrency(row.withdrawal_price) }}
          </template>
          <!-- 状态 -->
          <template slot="status" slot-scope="{ row }">
            <span v-if="row.status == -1" class="nouse_bg plub_width inline">已撤销</span>
            <span v-if="row.status == 1" class="wait_bg plub_width inline">待确认</span>
            <span v-if="row.status == 2" class="ableuse_bg plub_width inline">已完成</span>
          </template>
          <!-- 操作 -->
          <template slot="action" slot-scope="{ row }">
            <a v-if="row.status == 1" class="active_color" title="撤销" @click="backoutRefund(row)">撤销</a>
            <el-divider v-if="row.status == 1" direction="vertical" />
            <a v-if="row.status == 1 && row.check_count > 0" class="active_color" title="确认" @click="check(row)">确认</a>
            <a v-if="row.status == 2 && row.pic" class="active_color" title="查看凭证" @click="viewPic(row.pic)">查看凭证</a>
          </template>
        </zf-table>
      </el-tab-pane>
    </el-tabs>
    <ModelPayee :visible.sync="dialogFormVisible" :source="rechangeDetail" @submitFn="submitFn" />
    <ModalRefund :visible.sync="refundDialog" :source="refundDetail" @passFn="passFn" />
    <el-dialog title="微信商户号充值告知书" center="center" :visible.sync="letterVisible" :show-close="letterClose" width="600px">
      <el-card class="c3" style="max-height: 420px; line-height: 0;">
        <div>尊敬的客户: </div>
        <div class="mt20 lh26">
          <div class="ti24 mt10">关于我司微信商户号充值事宜，为统一规范管理，减少人为失误。特做出以下调整:</div>
          <div class="ti24 mt10">1、我司微信积分运营系统设置了余额不足提醒，当余额不足平均两日的消耗额时会进行短信提醒，请客户知悉。</div>
          <div class="ti24 red mt10"> 2、每个工作日11:30资金组成员会统一登录银行查询客户到款记录，进行统一充值。若于11:30后到账的款项，在下一时间节点统一充值。</div>
          <div class="ti24 red mt10">
            3、每个工作日17:30资金组成员会再次登录银行查询从11:30-17:30的客户到款记录，进行统一充值。17:30后到账的款项，将于下一个工作日的11:30统一查询充值。</div>
          <div class="ti24 mt10">4、其他特殊或紧急情况需联系我司相关人员进行紧急处理。</div>
          <div class="mt10">以上请各位客户相关负责人做好统筹。由此变化造成的不便，敬请谅解。</div>
          <div class="ti24 mt10">此致!</div>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="rechargeFn">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示" width="520px" center="center" :visible.sync="dialogTitleVisible">
      <div class="mb20">尊敬的用户您好，贵公司处于审核阶段，如急需发单请联系平台方处理！</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogTitleVisible = false">确定</el-button>
      </div>
    </el-dialog>
    <RechageDetail :visible.sync="visibleRechageDetail" :list="recharge_detail" />
    <WithdrawalDetail :visible.sync="visibleWithdrawalDetail" :list="withdrawal_detail" />
    <CheckRefund :visible.sync="checkDialog" :source="refundDetail" @checkFn="checkFn" />
  </div>
</template>

<script>
// 组件
import PriceRange from '@/components/priceRangeNew'
import ModelPayee from './components/ModelPayee'
import ModalRefund from './components/ModalRefund'
import CheckRefund from './components/CheckRefund'
import ZfTable from '@/components/ZfTable/CoreTable'
import column from './columns/refund'
import columnRechange from './columns/columnRechange'
import RechageDetail from './components/RechageDetail'
import WithdrawalDetail from './components/WithdrawalDetail'
// api接口
import { rechargeList, withdrawalList, rechargeAdd, revokeRecharge, withdrawal, revokeWithdrawal, getCompanyStatus, getRecharge, getWithdrawal, checkWithdrawal, quicklyRecharge } from '@/api/refund'
import dayjs from 'dayjs'
import { get, set } from '@/utils/storage'
import { isPuXing } from '@/utils/fn'
export default {
  components: {
    PriceRange,
    ModelPayee,
    ModalRefund,
    CheckRefund,
    RechageDetail,
    WithdrawalDetail,
    ZfTable
  },
  data() {
    return {
      column,
      columnRechange,
      activeName: '1',
      queryControl: {
        start_time: '',
        end_time: '',
        total: 0,
        pay_status: '',
        start_price: '',
        end_price: '',
        time: [dayjs(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        page: 1,
        pageSize: 10,
        status: ''
      },
      tableData: [],
      summary: {},
      recharge_type: 1,
      dialogFormVisible: false,
      // 退款状态
      refundDialog: false,
      checkDialog: false,
      refundDetail: {},
      summaryRefund: {},
      reFundFormQuery: {
        pageSize: 10,
        page: 1,
        start_time: '',
        end_time: '',
        status: '',
        time: [dayjs(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        total: 0
      },
      list: [],
      letterVisible: false,
      letterClose: false,
      dialogTitleVisible: false,
      rechangeDetail: {}, // 充值详情
      mch_arr: [], // 商户号列表
      visibleRechageDetail: false,
      recharge_detail: [],
      visibleWithdrawalDetail: false,
      withdrawal_detail: []
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    async getList() {
      const postData = {
        ...this.queryControl,
        ...this.priceTransform(this.queryControl, 'start_price', 'end_price'),
        start_time: this.queryControl.time ? this.$dayFormat(this.queryControl.time[0], 1) : '',
        end_time: this.queryControl.time ? this.$dayFormat(this.queryControl.time[1], 1) : ''
      }
      delete postData.time
      const res = await rechargeList(postData)
      if (res.code === 200) {
        this.queryControl.total = res.data.list.total
        this.tableData = res.data.list.data
        this.summary = res.data.total
        this.mch_arr = res.data.mch_arr
      }
    },
    query() {
      this.queryControl.page = 1
      this.getList()
    },
    toCharge() {
      this.recharge_type = 1
      getCompanyStatus().then(res => {
        if (res.code === 200) {
          if (res.data.status === 1) {
            this.dialogTitleVisible = true
          } else {
            if (get('rechargeLetterSkip') === 'true') {
              this.rechargeFn()
            } else {
              set('rechargeLetterSkip', 'true')
              this.letterVisible = true
            }
          }
        }
      })
    },
    interconvert() {
      this.recharge_type = 3
      getCompanyStatus().then(res => {
        if (res.code === 200) {
          if (res.data.status === 1) {
            this.dialogTitleVisible = true
          } else {
            if (get('rechargeLetterSkip') === 'true') {
              this.rechargeFn()
            } else {
              set('rechargeLetterSkip', 'true')
              this.letterVisible = true
            }
          }
        }
      })
    },
    resetForm() {
      this.queryControl = {
        start_time: '',
        end_time: '',
        total: 0,
        pay_status: '',
        start_price: '',
        end_price: '',
        time: [dayjs(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        page: 1,
        pageSize: 10,
        status: ''
      }
      this.query()
    },
    resetRefund() {
      this.reFundFormQuery = {
        pageSize: 10,
        page: 1,
        start_time: '',
        end_time: '',
        status: '',
        time: [dayjs(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        total: 0
      }
      this.queryRefund()
    },
    handlePageChangeRechange({ pageNum, pageSize, sorter: { prop, order }}) {
      this.queryControl.page = pageNum
      this.queryControl.pageSize = pageSize
      this.getList()
    },
    // 撤销充值
    backOut(row) {
      this.$confirm('撤销后该账号将无法得到充值，确认撤销此充值？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await revokeRecharge({ recharge_id: row.recharge_id })
        if (res.code === 200) {
          this.$message({ type: 'success', message: '撤销成功' })
          this.query()
        }
      })
    },
    // 极速到账
    quicklyRecharge(row) {
      this.$confirm('如果系统检测备用金充足，该笔充值将会立即到账，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await quicklyRecharge({ recharge_id: row.recharge_id })
        if (res.code === 200) {
          this.$message({ type: 'success', message: '成功到账' })
          this.query()
        }
      })
    },
    // 确认充值
    async submitFn(val) {
      const res = await rechargeAdd(val)
      if (res.code === 200) {
        this.$message({ type: 'success', message: '充值申请已提交!' })
        this.dialogFormVisible = false
        this.query()
      }
    },
    // 充值
    async rechargeFn() {
      if (this.recharge_type === 3) {
        this.$router.push('/interconvert')
      } else {
        this.$router.push('/payee_detail')
      }
    },
    viewPic(pic) {
      if (!pic) {
        this.$message({ type: 'error', message: '暂无凭证!' })
        return
      }
      if (process.env.NODE_ENV === 'development') {
        if (isPuXing()) {
          window.open(`${process.env.VUE_APP_PUXING_BASE_API}${pic}`)
        } else {
          window.open(`${process.env.VUE_APP_BASE_API}${pic}`)
        }
      } else {
        window.open(`${process.env.VUE_APP_BASE_API}${pic}`)
      }
    },
    handleClick(tab) {
      if (tab === '1') {
        this.query()
      } else {
        this.queryRefund()
      }
    },
    async getListOut() {
      const postData = {
        ...this.reFundFormQuery,
        start_time: this.reFundFormQuery.time ? this.$dayFormat(this.reFundFormQuery.time[0], 1) : '',
        end_time: this.reFundFormQuery.time ? this.$dayFormat(this.reFundFormQuery.time[1], 1) : ''
      }
      delete postData.time
      const res = await withdrawalList(postData)
      if (res.code === 200) {
        this.reFundFormQuery.total = res.data.list.total
        this.list = res.data.list.data
        this.summaryRefund = res.data.total
        this.mch_arr = res.data.mch_arr
      }
    },
    queryRefund() {
      this.reFundFormQuery.page = 1
      this.getListOut()
    },
    handlePageChange({ pageNum, pageSize, sorter: { prop, order }}) {
      this.reFundFormQuery.page = pageNum
      this.reFundFormQuery.pageSize = pageSize
      this.getListOut()
    },
    // 退款详情
    async refundFn(row) {
      this.$router.push('/refund_detail')
      // const res = await withdrawalInfo()
      // if (res.code === 200) {
      //   this.refundDetail = res.data
      //   this.refundDialog = true
      // }
    },
    // 退款确认提交
    async passFn(val) {
      const res = await withdrawal(val)
      if (res.code === 200) {
        this.$message({ type: 'success', message: '退款成功!' })
        this.queryRefund()
        this.refundDialog = false
      }
    },
    backoutRefund(row) {
      this.$confirm('确认撤销此退款？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await revokeWithdrawal({ withdrawal_id: row.withdrawal_id })
        if (res.code === 200) {
          this.$message({ type: 'success', message: '撤销成功' })
          this.queryRefund()
        }
      })
    },
    // 退款详情
    async check(row) {
      const res = await getWithdrawal({ withdrawal_id: row.withdrawal_id })
      if (res.code === 200) {
        this.refundDetail = res.data
        this.checkDialog = true
      }
    },
    // 退款确认提交
    async checkFn(val) {
      const res = await checkWithdrawal(val)
      if (res.code === 200) {
        this.$message({ type: 'success', message: '确认成功!' })
        this.queryRefund()
        this.checkDialog = false
      }
    },

    // 收款详情
    async rechargeDetail(row) {
      const res = await getRecharge({ recharge_id: row.recharge_id })
      if (res.code === 200) {
        this.recharge_detail = res.data.detail.map((item) => {
          return { ...item, price: item.price / 100 }
        })
        this.visibleRechageDetail = true
      }
    },
    // 退款详情
    async withdrawalDetail(row) {
      const res = await getWithdrawal({ withdrawal_id: row.withdrawal_id })
      if (res.code === 200) {
        this.withdrawal_detail = res.data.detail.map((item) => {
          return { ...item, price: item.price / 100 }
        })
        this.visibleWithdrawalDetail = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box-card{
  margin-right: 20px;
  margin-bottom: 20px;
  width: 275px;
  color: white;
  &:last-child{
    margin-right: 0;
  }
}
.red{
  color: red;
}
.box_wxbg{
  background-image: url(../../assets/wxshop.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.box_zfbbg{
  background-image: url(../../assets/zfbshop.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.box_icon{
  position: absolute;
  bottom: 20px;
  right: 10px;
  width: 38px;
  height: 38px;
  img{
    width: 100%;
    height: 100%;
  }
}
::v-deep{
  .el-dialog__body{
    padding: 15px 20px;
  }
  .el-dialog__footer {
    padding: 0px 10px 20px 10px;
}
}
.lh26{
  line-height: 26px;
}
</style>
